import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FindInformationLightMenuModule } from '@app/components/find-information/find-information-light-menu/find-information-light-menu.component';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-find-information-light',
  templateUrl: './find-information-light.component.html',
  styleUrls: ['./find-information-light.component.scss']
})
export class FindInformationLightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
@NgModule({
  declarations: [FindInformationLightComponent],
  exports: [FindInformationLightComponent],
  imports: [
    CommonModule,
    LinkModule,
    FindInformationLightMenuModule
  ]
})
export class FindInformationLightModule { }
